import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { makeDoorTypeOptions } from '@/constant/options';
import OptionsV2 from '../../PlaceFormV2Screen/components/OptionsV2';
import { FormGroup, SectionRoot, SubLabel } from './shared';
export default function DoorTypeCorrectionSection({ entranceDoorTypes = [], onChangeDoorTypes, }) {
    const options = makeDoorTypeOptions(entranceDoorTypes);
    return (_jsx(SectionRoot, { children: _jsxs(FormGroup, { children: [_jsx(SubLabel, { children: "\uCD9C\uC785\uBB38\uC740 \uC5B4\uB5A4 \uC885\uB958\uC778\uAC00\uC694?" }), _jsx(OptionsV2.Multiple, { options: options, values: entranceDoorTypes, columns: 2, onSelect: onChangeDoorTypes })] }) }));
}
